import React from 'react';
import ReactDOM from 'react-dom/client';

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { DataProvider } from './hooks/DataProvider';

import LoginPage from './pages/LoginPage';
import Logout from './pages/Logout';
import NotFound from './pages/NotFound';

import Settings from './pages/Settings';
import Main from './pages/Main';

import Consolidations from './pages/app/Consolidations';
import Consolidation from './pages/app/Consolidation';
import Shipments from './pages/app/Shipments';
import Shipment from './pages/app/Shipment';
import Document from './pages/app/Document';
import Documents from './pages/app/Documents';
import Tier from './pages/app/Tier';
import Tiers from './pages/app/Tiers';
import AuthZoho from './pages/AuthZoho';

import Test from './pages/Test';

import { RequireAuth } from './hooks/hooks';
import { Container } from '@mui/material';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const router = createBrowserRouter([
    { path: "/", element: <LoginPage /> },
    { path: "/test", element: <Test /> },
    { path: "/main", element: <RequireAuth><Main /></RequireAuth> },
    { path: "/settings", element: <RequireAuth><Settings /></RequireAuth> },
    { path: "/consolidations", element: <RequireAuth><Consolidations /></RequireAuth> },
    { path: "/consolidations/:consolidationId", element: <RequireAuth><Consolidation /></RequireAuth> },
    { path: "/shipments", element: <RequireAuth><Shipments /></RequireAuth> },
    { path: "/shipments/:shipmentId", element: <RequireAuth><Shipment /></RequireAuth> },
    { path: "/documents", element: <RequireAuth><Documents /></RequireAuth> },
    { path: "/documents/:documentId", element: <RequireAuth><Document /></RequireAuth> },
    { path: "/tiers", element: <RequireAuth><Tiers /></RequireAuth> },
    { path: "/tiers/:tierId", element: <RequireAuth><Tier /></RequireAuth> },
    {path: "/zoho_work_drive", element: <RequireAuth><AuthZoho /></RequireAuth>},
    { path: "/logout", element: <Logout /> },
    { path: "/404", element: <NotFound /> },
    { path: "*", element: <NotFound /> },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <DataProvider>
        <Container maxWidth="lg" sx={{ padding: 0, height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <RouterProvider router={router} />
        </Container>
    </DataProvider>
);

// Параметр maxWidth="xl" ты можешь заменить на нужный тебе (sm, md, lg, xl, false — для 100%).